export * from "./BNForm/BNForm";
export { default as ZErrorMap } from "./BNForm/i18n/all";
export * from "./BNForm/ZValidation";
export * from "./cloudinaryUrl/cloudinaryUrl";
export * from "./cmsUrlHelper/pushToDatalayer";
export * from "./cmsUrlHelper/url";
export { default as dataFromAttribute } from "./dataFromAttribute/dataFromAttribute";
export { default as getRouteAction } from "./dataUitAttributes/dataUitAttributes";
export * from "./DevPanel/DevPanel";
export { default as fetchSvg } from "./fetchSvg/fetchSvg";
export * from "./formatting/formatting";
export { default as BNGoogleTagManager } from "./GoogleTagManager/BNGoogleTagManager";
export * from "./GoogleTagManager/events/ApplicationDataLayerEvents";
export * from "./GoogleTagManager/events/FormSubmitMetadataDataLayerEvent";
export { default as pushValuesToDataLayer } from "./GoogleTagManager/pushValuesToDataLayer";
export { useTrackOnce } from "./GoogleTagManager/useTrackOnce";
export { default as isMenuItemSelected } from "./isMenuItemSelected/isMenuItemSelected";
export { default as logger } from "./logger/logger";
export * from "./mediaDocumentUrl/mediaDocumentUrl";
export * from "./reactNative/reactNative";
export * from "./sendJson/AntiForgeryConfig";
export { Method, default as sendJson } from "./sendJson/sendJson";
export * from "./storage/getStorage";
export * from "./translateNumbersToLowerCase/translateNumbersToLowerCase";
export * from "./urlUpdated/urlUpdated";
export { default as useDebouncedEffect } from "./useDebouncedEffect/useDebouncedEffect";
export { default as useDelayedLoading } from "./useDelayedLoading/useDelayedLoading";
export * from "./useKeyboardToggle";
export { default as useRootFontSize } from "./useRootFontSize/useRootFontSize";
export * from "./useStatePersisted/useStatePersisted";
export * from "./useTanStack";
export { default as useUserActivity } from "./useUserActivity/useUserActivity";
export { withCache } from "./withCache/withCache";
export { withStrictResolveOrder } from "./withStrictResolveOrder/withStrictResolveOrder";
export { SubsequentCallError, withThrottle } from "./withThrottle/withThrottle";
export { getXSRFtoken } from "./xsrfToken/xsrfToken";

import * as g from "./GoogleTagManager/BNGoogleTagManager";
import { AdjustableDataLayerEvent } from "./GoogleTagManager/events/AdjustableDataLayerEvent";
import { ApplicationFieldResult } from "./GoogleTagManager/events/ApplicationDataLayerEvents";
import { PublicPortalDataLayerEvent } from "./GoogleTagManager/events/PublicPortalDataLayerEvent";
import { UiElementClickEvent } from "./GoogleTagManager/UiElementClickEvent";

export * from "./sxMerge";

export const BNGoogleTagManagerCollection = {
  BNGoogleTagManager: g.BNGoogleTagManager,
  PublicPortalDataLayerEvent,
  EventCategory: g.EventCategory,
  EventAction: g.EventAction,
  EventLabel: g.EventLabel,
  DataLayerTransaction: g.DataLayerTransaction,
  DataLayerTransactionProductData: g.DataLayerTransactionProductData,
  FormFieldResult: ApplicationFieldResult,
  AdjustableDataLayerEvent,
  UiElementClickEvent,
  EventActionValue: g.EventActionValue,
};
